/* eslint-disable i18next/no-literal-string */
export const handle = { sitemap: { title: "FAQ" } };

export default function FAQ() {
  return (
    <div className="p-12">
      <h1 className="text-2xl font-bold">FAQ</h1>
    </div>
  );
}
